import { useAuiState } from '@assistant-ui/react';
import { last } from 'lodash';

export function useCanReloadMessage(): boolean {
  return useAuiState(({ thread, message }) => {
    const lastMessage = last(thread.messages);
    return message.id === lastMessage?.id && lastMessage?.role === 'assistant';
  });
}
